import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { LOGIN_SUCCESS, RE_LOGIN_SUCCESS } from '../../actions/login/index';
import ModalForgotPwd from '../../components/login/ModalForgotPwd';
import { openModal } from '../../actions/index';
import Loading from '../../components/common/Loading';
import { doActivePage } from '../../actions/menu/index';
import ForgotPwdForm from '../../components/login/ForgotPwdForm';
import '../../resources/css/layout/ForgotPwdLayout.scss';
import ModalConfirm from '../../components/common/ModalConfirm';
import ModalTip from '../../components/common/ModalTip';
import ModalAlert from '../../components/common/ModalAlert';
import ModalLoading from '../../components/common/ModalLoading';


class ForgotPwdLayout extends Component {

    constructor(props) {
        super(props);
        const { activePage, doActivePage } = this.props;
        if (activePage !== 'ForgotPassword') {
            doActivePage('ForgotPassword');
        }
    }

componentDidUpdate (prevProps, prevState, snapshot) {
  const { menuActivePage, history } = this.props;

  if (prevProps.menuActivePage !== menuActivePage) {
    if (menuActivePage && history) {
      history.push(window.CONFIG.WEB_ROOT + '/' + menuActivePage);
    }
  }
}

  loginAccount = (e) => {
    const { doActivePage /*, openModal */ } = this.props;
    // openModal("applyAccount", 'add', null, null);
    doActivePage('Login');
    // this.setState({displayPage: 'create'});
  }

  render() {
    const { status, loading } = this.props;
    
    if (status === LOGIN_SUCCESS || status === RE_LOGIN_SUCCESS) {      
      return (
        <Redirect to={{
          pathname: window.CONFIG.WEB_ROOT + window.CONFIG.DEFAULT_MAIN_PAGE
        }}/>
      );
    }

    return (
      <div className='area-forgot-password-page'>
        <div className='area-logo'>
          <span className='icon-logo-prism-dark-large'/>
        </div>
        <div className='area-forgot-password-block'>          
          <div className='area-forgot-password-logo-word'>
            <span className='logo-word'>Forgot Password</span>
          </div>
          <div className='area-signin-word' onClick={ this.loginAccount }>
            <span id="fogot-password-back" className='signin-link href-class'>Back to sign in page</span>
          </div>
          {/* <LoginForm></LoginForm> */}
          <ForgotPwdForm></ForgotPwdForm>
          <Loading loading={loading} center={true}></Loading>
        </div>
        {/* <div className='main-footer'>
          <MainFooter/>
        </div>*/}
        <ModalForgotPwd></ModalForgotPwd>
        {/* <div className='area-login-block'>          
          <div className='area-login-logo-word'>
            <span className='logo-word'>Create a Prism Account</span>
          </div>
          <div className='area-create-user-word' onClick={ this.applyAccount }>
            <span className='user-word'>Already have an account?</span><span className='create-user-link href-class'>Sign in</span>
          </div>
          <ApplyAccountForm></ApplyAccountForm>
          <Loading loading={loading} center={true}></Loading>
        </div> */}
        {/* <ModalApplyAccountDetail></ModalApplyAccountDetail> */}
        <ModalConfirm></ModalConfirm>
			  <ModalTip></ModalTip>
        <ModalAlert></ModalAlert>
        <ModalLoading></ModalLoading>
      </div>      
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // const errMsg = ownProps.location.state ? ownProps.location.state.errMsg : null;

  return {
    // errMsg: errMsg || state.loginReducers.errMsg,
    menuActivePage: state.menuReducers.activePage,
    status: state.loginReducers.status,
    loading: state.loginReducers.loading
  }
}

export default connect(
  mapStateToProps,
  { openModal, doActivePage }
)(ForgotPwdLayout)